export default {
  tutorial: {
    howToUse: {
      en: "How to use",
      pt: "Como começar",
    },
    createState: {
      title: {
        en: "To draw a state.",
        pt: "Criar um estado.",
      },
      text: {
        en: "Click on the screen.",
        pt: "Clique na tela.",
      },
    },
    createTransition: {
      title: {
        en: "To draw a transition.",
        pt: "Criar transição.",
      },
      text: {
        en: "Click on one state, then on the other.",
        pt: "Clique em um estado, depois no outro.",
      },
    },
    editState: {
      title: {
        en: "To edit a state.",
        pt: "Editar um estado.",
      },
      text: {
        en:
          "Right click on the state, then a menu will open, click outside the menu to confirm the changes.",
        pt:
          "Clique com o botão direito no estado, então um menu irá abrir, clique fora do menu para confirmar as mudanças.",
      },
    },
    editTransition: {
      title: {
        en: "To edit a rule.",
        pt: "Editar uma regra.",
      },
      text: {
        en:
          "Right click the rule, the a menu will open, where you can input whatever rule you want to that transition. Remembering that '.' is exchanged for 'λ', as well as leaving the field empty.",
        pt:
          "Clique com o botão direito na regra, então um menu irá abrir, onde você pode colocar qualquer regra que quiser para a transição. Lembre-se que '.' será trocado por 'λ', assim como deixar o campo vazio.",
      },
    },
    dontShowAgain: {
      en: "Don't show again",
      pt: "Não mostre isso novamente",
    },
  },
  modal: {
    regexToAutomaton: {
      title: {
        en: "Put the regex",
        pt: "Insira a regex",
      },
      alert: {
        en: "Empty Regex",
        pt: "Regex vazia",
      },
    },

    importDot: {
      en: "Import DOT",
      pt: "Importar DOT / TIKZ",
    },
    importGrammar: {
      en: "Import grammar",
      pt: "Importar gramática",
    },
    simulateAutomata: {
      en: "Simulate Automata",
      pt: "Simular Autômato",
    },
  },
  historic: {
    en: "Historic",
    pt: "Histórico",
  },
  today: { en: "Today", pt: "Hoje" },
  yesterday: { en: "Yesterday", pt: "Ontem" },
  lastWeeks: { en: "Last weeks", pt: "Últimas semanas" },
  alerts: {
    automatonError: {
      en: "Return the draw area and check the automaton",
      pt: "Retorne à area de desenho e corrija o autômato",
    },
    missRegex: {
      en: "Miss Regex",
      pt: "Falta Regex",
    },
  },
};
